import { getWorkspaceMembers } from '../API/services/companyService';
import { eliminateAlkemyMembers } from './workspaceUtils';

export const fetchUniqueWorkspaceMembers = async (currentWorkspace) => {
  const response = await getWorkspaceMembers({ limit: 100, offset: 0 });
  const filteredResponse = eliminateAlkemyMembers(response, currentWorkspace);

  if (filteredResponse?.collection) {
    const memberEmails = filteredResponse.collection
      .filter((member) => member.email && typeof member.email === 'string')
      .map((member) => member.email.toLowerCase());

    return [...new Set(memberEmails)];
  }

  return [];
};
